import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-kaHdQqaz.mjs"));
export {
  FilePickerVue
};
